import { defineSagaForService, QueriesSagasFactory } from '@repo/core'
import { all, takeLatest } from 'redux-saga/effects'
import { loadMasterTablesCatalogServiceConfig } from './masterTables'
import { loadNotificationsCatalogServiceConfig } from './notifications'
import { loadValidationsErrorsServiceConfig } from './validationsErrors'

export const serviceConfig = defineSagaForService({
  ...loadMasterTablesCatalogServiceConfig,
  ...loadNotificationsCatalogServiceConfig,
  ...loadValidationsErrorsServiceConfig,
})

const serviceSagas = Object.keys(serviceConfig).map((actionTypeRequest) =>
  takeLatest(actionTypeRequest, QueriesSagasFactory(serviceConfig, actionTypeRequest)),
)

export function* rootCatalogsSaga() {
  yield all(serviceSagas)
}
